/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-06-18 19:37:45
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-06-18 20:46:34
 * @FilePath: \ns-web-evaluation\pc\src\utils\nhIam.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { smSelf } from '@/utils/sm'
export const getRandomHash = (characters = '0123456789abcdefghijkl') => {
  let hash = ''
  for (let i = 0; i < 16; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    hash += characters[randomIndex]
  }
  return hash
}

export const iamLogin = () => {
  const stateVal = getRandomHash()
  localStorage.setItem('randomHash', smSelf.encryptBySm2(stateVal))
  location.href = `${
    location.hostname === 'ta.csair.com' ? 'https://iam.csair.com' : 'https://deviam.csair.com'
  }/idp/oauth2/authorize?client_id=PA&redirect_uri=${
    location.origin
  }/evaPc/activity/evaluation&response_type=code&state=${stateVal}`
}

export const iamLogout = () => {
  location.href = `${
    location.hostname === 'ta.csair.com' ? 'https://iam.csair.com' : 'https://deviam.csair.com'
  }/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=${
    location.origin
  }/evaPc/activity/evaluation&redirectToLogin=true&entityId=PA`
}
